var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/display-name */
import * as React from 'react';
var SvgCheck = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props, { ref: ref }),
    React.createElement("path", { d: "M23.156 2.406a2.052 2.052 0 00-2.888.442L9.976 16.943 3.39 11.627a2.051 2.051 0 00-2.063-.348 2.093 2.093 0 00-.517 3.602l8.263 6.67a2.03 2.03 0 001.29.449 2.066 2.066 0 001.663-.834l11.567-15.84a2.097 2.097 0 00-.438-2.92z" }))); });
export default SvgCheck;
//# sourceMappingURL=Check.js.map